export default {
  settings: {
    hasGamerCondition: true,
    isPlaytimeByPeriod: true,
    isPlaytimeReverse: true
  },
  actionTypes: {
    score: [
      'FINISH_GAME',
      'PREMATURE_WIN'
    ]
  },
  modules: {
    info: [
      'timer',
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      score: ingameData => ingameData.score
    },
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    gamerCondition: {
      home: {
        eventCode: '',
        title: '...'
      },
      away: {
        eventCode: '',
        title: '...'
      }
    },
    weightClass: ''
  }
}
